import script from "./LeftPane.vue?vue&type=script&setup=true&lang=ts"
export * from "./LeftPane.vue?vue&type=script&setup=true&lang=ts"

import "./LeftPane.vue?vue&type=style&index=0&id=25193f48&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25193f48"]])

export default __exports__